import { KeyboardArrowDown } from "@mui/icons-material";
import styles from "./selector-pill.module.css";
import { ReactNode, useEffect, useRef, useState } from "react";

export default function SelectorPill({
  children,
  value,
  hasError,
  onSelect,
}: {
  children: ReactNode;
  value: string;
  hasError: boolean;
  onSelect: (newValue: number) => void;
}) {
  const [isActive, setIsActive] = useState(false);
  const toggleRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        toggleRef.current &&
        !toggleRef.current.contains(event.target as Node)
      ) {
        setIsActive(false);
      }
    };
    if (isActive) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isActive]);
  return (
    <div className={styles.selectorItem}>
      {children}
      <div ref={toggleRef} className={styles.selectorWrapper}>
        <button
          className={`${styles.selector} ${hasError && styles.error}`}
          onClick={() => {
            setIsActive(!isActive);
          }}
        >
          <span className={styles.selectedNumber}>{value}</span>
          <KeyboardArrowDown />
        </button>
        {isActive && (
          <div className={styles.selection}>
            {[...Array(81)].map((_, i) => (
              <button
                className={styles.selectionWrapper}
                key={i}
                onClick={(e) => {
                  onSelect(i);
                  setIsActive(false);
                }}
              >
                <span>{i}</span>
                <div className={styles.separator}></div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
